import { TSpanElement } from './TSpanElement'

export class TextNode extends TSpanElement {
  override type = 'textNode'
}
